import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { CODELESS_CONVERSION_TYPE_OPTIONS } from './codelessConversionTypeOptions';

export const conversionTypeOptions = [
    {
        value: CODELESS_CONVERSION_TYPE_OPTIONS.BUTTON_CLICKS,
        title: <FormattedMessage id="codeless.conversion.type.button.click" defaultMessage="Button Clicks" />,
        description: (
            <FormattedMessage
                id="codeless.conversion.type.button.click.description"
                defaultMessage="Track when users click on a specific button or element. For instance, you can monitor when someone clicks the 'Add to Cart' button and record this action as an 'Add to Cart' event."
            />
        ),
    },
    {
        value: CODELESS_CONVERSION_TYPE_OPTIONS.URL_VISITS,
        title: <FormattedMessage id="codeless.conversion.type.url.visits" defaultMessage="URL Visits" />,
        description: (
            <FormattedMessage
                id="codeless.conversion.type.url.visits.description"
                defaultMessage="Track when a URL containing a specific keyword is visited. For example, you can record a 'View Content' event when someone visits a URL that includes the '/product' keyword."
            />
        ),
    },
];
